module.exports = __webpack_public_path__ + "img/logo.d924f58b.png";